import {
  label,
  useEnvironment,
} from "@keycloak/keycloak-ui-shared";

import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Link,
  List,
  ListItemButton,
  ListItemIcon,
  ListSubheader,
  Popover,
  Stack,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { useTranslation } from "react-i18next";

import { environment } from "../environment";

import { useState } from "react";
import MenuIcon from "../icons/Menu";
import SignOutIcon from "../icons/SignOut";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { KeycloakTokenParsed } from "libs/keycloak-js/lib/keycloak";
import { TFunction } from "i18next";
import LaunchIcon from '@mui/icons-material/Launch';
import React from "react";
import {
  AvatarButton,
  headerAvatarStyles,
  headerIconStyles,
  headerListItemButtonStyles,
  headerListItemIconStyles,
  headerListSubHeadStyles,
  headerPopoverListStyles,
  headerPopoverStyles,
  referrerLinkBoxStyles,
  referrerLinkIconStyles
} from "./styles";


const ReferrerLink = () => {
  const { t } = useTranslation();

  return environment.referrerUrl ? (
    <Link
      data-testid="referrer-link"
      component="a"
      href={environment.referrerUrl?.replace("_hash_", "#")}
    >
      <Box sx={referrerLinkBoxStyles}>
        <LaunchIcon sx={referrerLinkIconStyles} />
        {t("backTo", {
          app: label(t, environment.referrerName, environment.referrerUrl),
        })}
      </Box>
    </Link>
  ) : null;
};

interface HeaderProps {
  openMenuHandler: () => void;
}

export function loggedInUserName(
  token: KeycloakTokenParsed | undefined,
  t: TFunction,
) {
  if (!token) {
    return t("unknownUser");
  }

  const givenName = token.given_name;
  const familyName = token.family_name;
  const preferredUsername = token.preferred_username;

  if (givenName && familyName) {
    return t("fullName", { givenName, familyName });
  }

  return givenName || familyName || preferredUsername || t("unknownUser");
}

export const Header = ({ openMenuHandler }: HeaderProps) => {
  const { keycloak } = useEnvironment();
  const { t } = useTranslation();
  const isMobileSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorElUser);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const picture = keycloak.idTokenParsed?.picture;

  return (
    <Box sx={{ flexGrow: 0 }}>
      <Stack direction="row" spacing={2} alignItems={'center'}>
        <ReferrerLink />
        {!isMobileSm && <AvatarButton disableRipple onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar alt={t("avatar")} sx={headerAvatarStyles} src={picture} />
          { open ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" /> }
        </AvatarButton>}
        {/* <IconButton disableRipple onClick={openMenuHandler}>
          <MenuIcon />
        </IconButton> */}
      </Stack>
      <Popover
        open={open}
        anchorEl={anchorElUser}
        onClose={handleCloseUserMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={headerPopoverStyles}
      >
        <List
          sx={headerPopoverListStyles}
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader sx={headerListSubHeadStyles} component="div" id="nested-list-subheader">
              {loggedInUserName(keycloak.idTokenParsed, t)}
            </ListSubheader>
          }
        >
          <Divider />
          <ListItemButton sx={headerListItemButtonStyles} onClick={() => keycloak.logout()}>
            <ListItemIcon sx={headerListItemIconStyles}>
              <SignOutIcon sx={headerIconStyles} />
            </ListItemIcon>
            <Typography variant="body2">
              {t("signOut")}
            </Typography>
          </ListItemButton>
        </List>
      </Popover>
    </Box>
  );
};
